import React, {useState, useEffect} from 'react'
import styles from './MarketingStockCatalogComponent.module.css'
import './MarketingStockCatalogComponent.css'
import { Carousel } from 'primereact/carousel';
import { useNavigate } from 'react-router-dom'
import {useWindowDimensions} from '../../../Context/WindowDimensionsContext'


export const MarketingStockCatalogComponent = ({stockList}) => {

    const [validateStockList, setValidateStockList] = useState([])
    const navigate = useNavigate()
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    useEffect(() => {
        if(stockList && stockList.length){
            validate(stockList)
        }
    }, [stockList])

    const validate = (stockList) => {
        const validateArray = [];

        stockList.forEach(element => {
            if(element.WideImageUrls.length){
                validateArray.push(element)
            }
        });

        setValidateStockList(validateArray);
    }

    const onPhotoClick = (event, item) => {
        navigate('/stock/' + item.Id)
    }

    const stockTemplate = (item) => {
        return <img className={styles.stockImage} src={item.WideImageUrls[0]} onClick={(e) => onPhotoClick(e, item) } />;
    };

    const getCarouselStyleObject = () => {
        if(viewPortWidth > 700) {
            return {
                paddingTop:'20px', borderRadius:'10px'
            }
        }
        else if(viewPortWidth <= 700){
            return {
                paddingTop:'20px', borderRadius:'10px'
            }
        }
    }

    return (
        <div className={`${styles.sliderWrapper} sliderWrapper `} >
            { validateStockList && validateStockList.length > 0 &&
                <Carousel value={validateStockList} style={getCarouselStyleObject()}  numVisible={1} className="custom-carousel" circular
                          autoplayInterval={5000} itemTemplate={stockTemplate} />
            }
        </div>
    )
}